import Map from "./Map"
import { MAP_STYLES } from "web/components/Map/MapConstants"
import { useLocation } from "react-router-dom"
import { useSetting } from "web/hooks/data"

export default function SettingsMap({
  mapId,
  locations,
  centralLocation,
  lngLatFn,
  isStatic,
  buttons,
  distanceCondition,
  children,
  categoryField,
  categories,
  onLocationClick,
  isLoading,
  showOrdinals,
}) {
  const { pathname } = useLocation()

  const hasCentralLocation = !!centralLocation

  const SAVED_CENTER_KEY = `map-center-${pathname}`
  const SAVED_ZOOM_KEY = `map-zoom-${pathname}`

  const mapCenter = JSON.parse(sessionStorage.getItem(SAVED_CENTER_KEY))
  const zoom =
    JSON.parse(sessionStorage.getItem(SAVED_ZOOM_KEY)) ||
    (hasCentralLocation || isStatic ? 14 : 10)

  const [style, setMapStyle] = useSetting({
    scope: "user",
    setting: "map-style",
    defaultValue: MAP_STYLES.streets,
  })

  function handleZoomChange(zoomLevel) {
    sessionStorage.setItem(SAVED_ZOOM_KEY, JSON.stringify(zoomLevel))
  }

  function handleMapCenterChange(mapCenter) {
    sessionStorage.setItem(SAVED_CENTER_KEY, JSON.stringify(mapCenter))
  }

  function handleStyleChange(style) {
    setMapStyle(style)
  }

  return (
    <Map
      mapId={mapId}
      locations={locations}
      centralLocation={centralLocation}
      lngLatFn={lngLatFn}
      isStatic={isStatic}
      canRecenterMap={true}
      buttons={buttons}
      distanceCondition={distanceCondition}
      children={children}
      categoryField={categoryField}
      categories={categories}
      onLocationClick={onLocationClick}
      zoom={zoom}
      style={style}
      savedMapCenter={mapCenter}
      handleZoomChange={handleZoomChange}
      handleMapCenterChange={handleMapCenterChange}
      handleStyleChange={handleStyleChange}
      isLoading={isLoading}
      showOrdinals={showOrdinals}
    />
  )
}
